import { fetcher, getBaseUrl } from '@docnboard/rest';

import type { Board } from '../model';

export const getFileImportBoard = async (board: Board) => {
  // TODO переделать на сгенерированный api
  const result = await fetcher(
    `/api/v2/services/miro/boards/${board.boardId}/snapshot`,
    {
      timeout: Number.MAX_SAFE_INTEGER,
    }
  );
  const buffer = await result.arrayBuffer();
  const blob = new Blob([buffer]);
  const file = new File([blob], board.name + '.zip', {
    type: 'application/zip',
  });

  return file;
};

export const getUrlLogin = () => {
  return `${getBaseUrl()}/api/v2/services/miro/auth/login`;
};
